import React from 'react';
import { Text, Box, Button, Input, Image, Divider, Select } from '@chakra-ui/react';
import { DashboardSection } from '../../components/DashboardStyles';
import previewProductImgL from 'assets/preview-product-imgL.png';
import previewProductImg1 from 'assets/preview-product-img1.png';
import previewProductImg2 from 'assets/preview-product-img2.png';
import previewProductImg3 from 'assets/preview-product-img3.png';
import recommendedProductImg from 'assets/recommended-product-img.png';

export default function CreateProduct() {
    const [size, setSize] = React.useState('Small');

    const handleSize = (e) => {
        setSize(e.target.value);
    };

    return (
        <DashboardSection>
            <Box
                display="grid"
                gridTemplateColumns={{
                    base: '1fr',
                    sm: '1fr',
                    md: '60% 40%',
                    lg: '60% 40%',
                }}
                marginBottom="3rem"
                gap="2rem">
                <Box display="grid" gridTemplateColumns="10% 90%" gap="1rem">
                    <Box display="flex" flexDirection="column" gap="1rem">
                        <Image src={previewProductImg1} alt="" />
                        <Image src={previewProductImg2} alt="" />
                        <Image src={previewProductImg3} alt="" />
                    </Box>
                    <Box>
                        <Image src={previewProductImgL} alt="" />
                    </Box>
                </Box>
                <Box>
                    <Box>
                        <Text fontSize="lg" paddingBottom="1rem">
                            H&M Stylish Sweatshirt
                        </Text>
                        <Box marginBottom=".5rem" fontSize="sm" display="flex" gap="2rem">
                            <Text fontWeight="600" display="inline">
                                N1,500
                            </Text>{' '}
                            <s>N1,500</s>
                        </Box>
                        <Box display="flex" flexDirection="column" gap=".5rem" marginBottom=".8rem">
                            <Text fontSize="sm" fontWeight="500">
                                Color: Black
                            </Text>
                            <Box display="flex" gap=".5rem">
                                {['#000000', '#1b3b5f', '#F97066'].map((color, index) => (
                                    <Box
                                        key={index}
                                        width="20px"
                                        height="20px"
                                        background={color}
                                        borderRadius="50%"
                                        outline={color === '#000000' ? '1px solid #000000' : ''}
                                        outlineOffset={color === '#000000' ? '3px' : ''}></Box>
                                ))}
                            </Box>
                        </Box>
                        <Box marginBottom=".8rem" fontSize="sm">
                            <Text paddingBottom=".5rem" fontWeight="500">
                                Size: {size}
                            </Text>
                            <Select
                                placeholder="Small"
                                onChange={handleSize}
                                width="200px"
                                fontSize="sm">
                                <option value="Small">Small</option>
                                <option value="Medium">Medium</option>
                                <option value="Large">Large </option>
                                <option value="X-large">X-Large</option>
                            </Select>
                        </Box>
                        <Box
                            marginBottom=".5rem"
                            fontSize="sm"
                            display="flex"
                            gap="1rem"
                            alignItems="center">
                            <Text display="inline" fontWeight="500">
                                Quantity:
                            </Text>
                            <Input display="inline" type="number" min="1" max="10" width="100px" />
                        </Box>
                    </Box>
                    <Divider size="md" marginBottom=".5rem" />
                    <Box
                        display={{
                            base: 'flex',
                            sm: 'flex',
                            md: 'block',
                            lg: 'block',
                        }}
                        flexDirection="column"
                        alignItems="center">
                        <Box marginBottom=".8rem">
                            <Text fontSize="sm" paddingBottom=".5rem" fontWeight="500">
                                Product description
                            </Text>
                            <Text fontSize="sm">
                                lorem ipsum mons chinda ynesder dghfyuur dhhdhjdjk sghjloojhgds
                                asdffgikmnc
                            </Text>
                        </Box>
                        <Button background="#1b3b5f" color="#ffffff" width="100%" fontSize="sm">
                            Add To Cart
                        </Button>
                        <Text fontSize="sm">
                            This product will be delivered between 3 - 5 business days of order.
                        </Text>
                    </Box>
                </Box>
            </Box>
            <Divider marginBottom="5rem" />
            <Box
                display={{
                    base: 'flex',
                    sm: 'flex',
                    md: 'block',
                    lg: 'block',
                }}
                flexDirection={{
                    base: 'column',
                    sm: 'column',
                }}
                alignItems="center">
                <Text fontWeight="600" fontSize="lg" marginBottom="2rem">
                    Recommended Products
                </Text>
                <Box
                    display="flex"
                    gap="1rem"
                    flexWrap="wrap"
                    flexDirection={{
                        base: 'column',
                        sm: 'column',
                        md: 'row',
                        lg: 'row',
                    }}
                    alignItems="center">
                    {[1, 2, 3, 4].map((item, index) => (
                        <Box key={index}>
                            <Image
                                src={recommendedProductImg}
                                alt=""
                                width="`12rem"
                                height="12rem"
                            />
                            <Text fontSize="sm">H&M Stylish Sweatshirt</Text>
                            <Text fontSize="sm">N1,500.00</Text>
                        </Box>
                    ))}
                </Box>
            </Box>
        </DashboardSection>
    );
}
